import client from "./client";

const GroupService = {};

GroupService.get = function (data) {
  return client.get(`/group`, data);
};
GroupService.getSummary = function () {
  return client.get(`/group/summary`);
};
GroupService.getOrCreate = function (data) {
  return client.post(`/group`, data);
};

GroupService.getGroupDetails = function (groupId) {
  return client.get(`/group/${groupId}`);
};

GroupService.changeStatus = function (groupId, status, data) {
  return client.put(`/group/change-status/${groupId}/${status}`, data);
};

GroupService.changeSchedule = function (groupId, scheduleId) {
  return client.put(`/group/change-schedule/${groupId}`, { scheduleId });
};

GroupService.sendSms = function (groupId, data) {
  return client.post(`/group/sms-sender/${groupId}`, data);
};

GroupService.checkOrderNumber = function(orderNumber) {
  return client.get(`/group/check-order-number/${orderNumber}`);
}

GroupService.checkGroupName = function(groupName) {
  return client.get(`/group/check-group-name/${groupName}`);
}

export default GroupService;
